import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _get from "@babel/runtime/helpers/get";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { DragTargetHandler } from "./base/DragTargetHandler";
export var SidebarDragTargetHandler = /*#__PURE__*/function (_DragTargetHandler) {
  _inherits(SidebarDragTargetHandler, _DragTargetHandler);
  var _super = _createSuper(SidebarDragTargetHandler);
  function SidebarDragTargetHandler(dragStatus) {
    var _thisSuper, _this;
    _classCallCheck(this, SidebarDragTargetHandler);
    _this = _super.call(this);
    _this.dragStatus = dragStatus;
    _defineProperty(_assertThisInitialized(_this), "lastPoint", {});
    _defineProperty(_assertThisInitialized(_this), "handleDragOverEnter", function (event) {
      if (event.isTrusted || !_this.dragStatus.getIsDragging()) return;
      var _ref = [event.pageX, event.pageY],
        x = _ref[0],
        y = _ref[1];
      if (_this.lastPoint.x !== x || _this.lastPoint.y !== y) {
        _this.dragStatus.emitSidebarDrag({
          x: x,
          y: y
        });
        _this.lastPoint = {
          x: x,
          y: y
        };
      }
      _get((_thisSuper = _assertThisInitialized(_this), _getPrototypeOf(SidebarDragTargetHandler.prototype)), "handleDragOverEnter", _thisSuper).call(_thisSuper, event);
    });
    return _this;
  }
  _createClass(SidebarDragTargetHandler, [{
    key: "handleDrop",
    value: function handleDrop(event) {
      if (event.isTrusted || !this.dragStatus.getIsDragging()) return;
      var _ref2 = [event.pageX, event.pageY],
        x = _ref2[0],
        y = _ref2[1];
      this.dragStatus.emitSidebarDrop({
        x: x,
        y: y
      });
      _get(_getPrototypeOf(SidebarDragTargetHandler.prototype), "handleDrop", this).call(this, event);
    }
  }, {
    key: "handleDragLeave",
    value: function handleDragLeave() {}
  }]);
  return SidebarDragTargetHandler;
}(DragTargetHandler);